<div class="bubble-speach-tooltip box-shadow" *ngIf="alerts.length > 0">
  <label
    *ngFor="let alert of alerts"
    [ngbPopover]="alertContent"
    [ngClass]="{ selected: alert.selected }"
    placement="{{ tooltipPlacement }}"
    popoverClass="instructions-popover"
    triggers="click"
    (mouseenter)="alert.selected = !alert.selected"
    (mouseleave)="alert.selected = !alert.selected"
  >
    <span> {{ alert.id }} {{ alert.name }} </span>
    <ng-template #alertContent>
      <div [innerHTML]="alert.instructions | safe: 'html'"></div>
    </ng-template>
  </label>
</div>
